// extracted by mini-css-extract-plugin
module.exports = {"container":"style__container__k+v6j","veryHigh":"style__veryHigh__qBAjp","high":"style__high__6x6gq","mid":"style__mid__ZziNe","average":"style__average__Zj-5W"};